import { Spacer } from "@hackthenorth/north";
import { Button } from "north.js";
import React from "react";
import styled from "styled-components";

import Modal from "src/shared/components/Modal";

interface ShipmentWarningModalProps {
  isOpen: boolean;
  warnings: string[];
  onCancel: () => void;
  onConfirm: () => void;
}

export const ShipmentWarningModal: React.FC<ShipmentWarningModalProps> = ({
  isOpen,
  warnings,
  onCancel,
  onConfirm,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title="Are you sure you want to submit?"
    width="480px"
    actions={
      <>
        <Button color="secondary" onClick={onCancel}>
          Go back
        </Button>
        <Spacer width="16px" />
        <Button color="primary" onClick={onConfirm}>
          Submit anyway
        </Button>
      </>
    }
  >
    {warnings.map((warning, i) => (
      <WarningText key={i}>{warning}</WarningText>
    ))}
  </Modal>
);

const WarningText = styled.p`
  margin: 0 0 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.globalConstants.color.textBody};

  &:last-child {
    margin-bottom: 0;
  }
`;
